import { render, staticRenderFns } from "./SectorLanding.vue?vue&type=template&id=60bae9b3"
import script from "./SectorLanding.vue?vue&type=script&lang=js"
export * from "./SectorLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60bae9b3')) {
      api.createRecord('60bae9b3', component.options)
    } else {
      api.reload('60bae9b3', component.options)
    }
    module.hot.accept("./SectorLanding.vue?vue&type=template&id=60bae9b3", function () {
      api.rerender('60bae9b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/SectorLanding.vue"
export default component.exports